import React from "react";
import cx from "classnames";
import Nodata from "assets/images/home/nodata.png";
import { PUBLIC_FEED_TAB } from "@/components/Pages/Notification/utils/publicFeedConstants";
import styles from "./index.module.less";

function IconChevronRight({ className }) {
  return (
    <svg className={className} width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default function NotificationPublicFeed({ t, activeTab, feedState, moreUrl, loading }) {
  const { list, grouped } = feedState || { list: [], grouped: null };

  const openUrl = (url) => {
    if (url) window.open(url, "_blank");
  };

  if (loading) {
    return null;
  }

  if (activeTab === PUBLIC_FEED_TAB.NEWS) {
    if (!grouped || !grouped.length) {
      return (
        <div className={styles.emptyCard}>
          <img src={Nodata} alt="" className={styles.emptyImg} />
          <p>{t("home.noData")}</p>
        </div>
      );
    }

    return (
      <>
        <div className={styles.timeline}>
          <div className={styles.timelineRail} aria-hidden />
          {grouped.map((group) => (
            <div key={group.dayKey} className={styles.timelineGroup}>
              <div className={styles.timelineDayRow}>
                <span className={styles.timelineDiamond} aria-hidden />
                <span className={styles.timelineDayLabel}>{group.label}</span>
              </div>
              {group.items.map((item) => (
                <div key={item.id} className={styles.timelineItem}>
                  <span className={styles.timelineNode} aria-hidden />
                  <button
                    type="button"
                    className={styles.timelineCard}
                    onClick={() => openUrl(item.url)}
                  >
                    <div className={cx(styles.timelineTime, styles.tnum)}>{item.timeStr}</div>
                    <span className={styles.timelineTitle}>{item.title}</span>
                  </button>
                </div>
              ))}
            </div>
          ))}
        </div>
      </>
    );
  }

  if (!list.length) {
    return (
      <div className={styles.emptyCard}>
        <img src={Nodata} alt="" className={styles.emptyImg} />
        <p>{t("home.noData")}</p>
      </div>
    );
  }

  const isAcademy = activeTab === PUBLIC_FEED_TAB.ACADEMY;

  return (
    <>
      <ul className={styles.listCard}>
        {list.map((item) => {
          const hasCover = isAcademy && !!(item.coverImageSrc && String(item.coverImageSrc).trim());
          return (
            <li key={item.id} className={styles.listItem}>
              <button type="button" className={styles.row} onClick={() => openUrl(item.url)}>
                <div className={styles.rowMain}>
                  {!isAcademy && item.date ? (
                    <div className={styles.rowMeta}>
                      <span className={cx(styles.rowDate, styles.tnum)}>{item.date}</span>
                    </div>
                  ) : null}
                  <h3 className={styles.rowTitle}>{item.title}</h3>
                  {isAcademy && item.tags && item.tags.length > 0 ? (
                    <div className={styles.tagRow}>
                      {item.tags.map((tag, idx) => (
                        <span key={`${item.id}-tag-${idx}`} className={styles.tag}>
                          {tag}
                        </span>
                      ))}
                    </div>
                  ) : null}
                </div>
                {hasCover ? (
                  <img
                    src={item.coverImageSrc}
                    alt=""
                    className={styles.rowCover}
                    loading="lazy"
                    decoding="async"
                    onError={(e) => {
                      e.currentTarget.style.display = "none";
                    }}
                  />
                ) : null}
                <IconChevronRight className={styles.rowChevron} />
              </button>
            </li>
          );
        })}
      </ul>

      {moreUrl ? (
        <button type="button" className={styles.viewMore} onClick={() => openUrl(moreUrl)}>
          {t("home.ViewMore") || "View More"}
        </button>
      ) : null}
    </>
  );
}
